export interface IDeclineSelectionPayload {
    wageRepairRequested: boolean;
    bankingRoutingRequiresReview: boolean;
    bankingAccountRequiresReview: boolean;
    declineReasonSummary?: string;
}

export function buildDeclineSelectionPayload(
    wages: boolean,
    routing: boolean,
    account: boolean,
    declineReasonSummary?: string
): IDeclineSelectionPayload {
    return {
        wageRepairRequested: wages,
        bankingRoutingRequiresReview: routing,
        bankingAccountRequiresReview: account,
        declineReasonSummary: declineReasonSummary || undefined
    };
}
